import { Component, Input } from '@angular/core';
import { ModalService } from '../../../services';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';

@Component({
  selector: 'app-form-modal',
  templateUrl: './form-ok-modal.component.html',
  styleUrl: './form-ok-modal.component.scss',
})
export class FormOkModalComponent {
  @Input() header: string;
  @Input() message: string;
  @Input() okLabel = $localize`Ok`;
  @Input() fields: FormlyFieldConfig[];
  @Input() model: any = {};

  constructor(private modalService: ModalService) {}

  onOk() {
    this.modalService.close(this.model);
  }

  onCancel() {
    this.modalService.dismiss();
  }
}
